import React from 'react';
import { Flex, Text } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import storage from "utils/storage";

const getPermitedList = ({ permStList }) => {
  if (!permStList) {
    return [];
  }

  let newitems = [];
  let sumitems = [];

  // row 1
  sumitems = [];
  if (permStList.perm_account_view_all) {
    sumitems.push({
      key: "manageusers",
      type: "btn-solid",
      label: "Users",
    });
  } else if (permStList?.perm_account_view_theirs) {
    sumitems.push({
      key: "manageusers",
      type: "btn-solid",
      label: "Account",
    });
  }

  if (permStList.perm_group_create || permStList.perm_group_edit) {
    sumitems.push({
      key: "managegroups",
      // type: "btn-gray",
      type: "btn-solid",
      label: "Groups",
    });
  }

  if (sumitems && sumitems[0]) {
    newitems.push({
      key: "empty-1",
      type: "heading-empty",
      label: "",
      items: sumitems,
    });
  }

  // row 2
  sumitems = [];
  if (permStList.perm_refunds_view) {
    sumitems.push({
      key: "return",
      type: "btn-solid",
      label: "View Returns",
    });
  }

  if (permStList.perm_refund_rules_view) {
    sumitems.push({
      key: "pricing",
      type: "btn-solid",
      label: "Pricing & Returns Rules",
    });
  }

  if (sumitems && sumitems[0]) {
    newitems.push({
      key: "Pricing & Returns",
      type: "heading",
      label: "Pricing & Returns",
      items: sumitems,
    });
  }

  // row 3
  sumitems = [];
  if (
    permStList.perm_commission_sheet_view ||
    permStList.perm_commission_sheet_view_all
  ) {
    sumitems.push({
      key: "commissionsheets",
      type: "btn-solid",
      label: "Commission Sheets",
    });
  }

  if (
    permStList.perm_commission_rules_view_all ||
    permStList.perm_commission_rules_view_theirs
  ) {
    sumitems.push({
      key: "commissionrules",
      type: "btn-solid",
      label: "Commission Rules",
    });
  }

  if (sumitems && sumitems[0]) {
    newitems.push({
      key: "Commission",
      type: "heading",
      label: "Commission",
      items: sumitems,
    });
  }

  // row 4
  sumitems = [];
  if (permStList.perm_pricing_view) {
    sumitems.push({
      key: "policies",
      type: "btn-solid",
      label: "Pricing",
    });
    sumitems.push({
      key: "duration",
      type: "btn-solid",
      label: "Duration",
    });
    sumitems.push({
      key: "covertypes",
      type: "btn-solid",
      label: "Cover Types",
    });
    sumitems.push({
      key: "claimlimits",
      type: "btn-solid",
      label: "Claim Limits",
    });
  }

  if (sumitems && sumitems[0]) {
    newitems.push({
      key: "Pricings",
      type: "heading",
      label: "Pricing Setup",
      items: sumitems,
    });
  }

  // row 5
  sumitems = [];
  if (permStList.perm_settings_change_vat) {
    sumitems.push({
      key: "vat",
      type: "btn-solid",
      label: "VAT",
    });
  }

  if (permStList.perm_perm_view_profile) {
    sumitems.push({
      key: "permissionprofiles",
      type: "btn-solid",
      label: "Permissions",
    });
  }

  if (sumitems && sumitems[0]) {
    newitems.push({
      key: "Settings",
      type: "heading",
      label: "Settings",
      items: sumitems,
    });
  }

  // row 5
  sumitems = [];
  if (permStList.perm_payments_view) {
    sumitems.push({
      key: "paymentsout",
      type: "btn-solid",
      label: "Payments Out",
    });
  }

  if (permStList.perm_payment_received_view) {
    sumitems.push({
      key: "paymentsreceived",
      type: "btn-solid",
      label: "Payments In",
    });
  }

  if (permStList.perm_schedule_view) {
    sumitems.push({
      key: "schedule",
      type: "btn-solid",
      label: "Schedule",
    });
  }

  if (sumitems && sumitems[0]) {
    newitems.push({
      key: "empty-2",
      type: "heading-empty",
      label: " ",
      items: sumitems,
    });
  }

  return newitems;
};

function Manage() {
  // const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const onClickBtn = (action) => {
    if (action) {
      navigate(`/${action}`);
    }
    // window.location.href = `${action}`;
  };

  const { permStList } = storage.get("loginRes");
  const items = getPermitedList({ permStList });

  useEffect(() => {
    // setIsLoading(true);
    console.log("useEffect", permStList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Manage"} isLoading={false} />
      {/* <Flex width={"100%"} gap={"1rem"}> */}
      <Flex flex={1} overflow="auto" direction={"column"}>
        {items?.map((item) => (
          <React.Fragment key={item?.key}>
            <Text
              mt={item?.label ? "2rem" : "0rem"}
              fontWeight={"bold"}
              textStyle={"sm"}
              color="textv2.base"
            >
              {item?.label}
            </Text>

            {item?.items?.map ? (
              <Flex wrap={"wrap"} mt={"0.5rem"} gap={"0.5rem"}>
                {item?.items?.map((item2) => (
                  <ButtonComp
                    key={item2?.key}
                    label={item2?.label}
                    onClick={() => onClickBtn(item2?.key)}
                    keyname={"manage-item-btn"}
                    // bg={
                    //   item?.type === "heading-empty" ? "primary" : "fontdark"
                    // }
                    // color={"white"}
                    size={"xl"}
                  />
                ))}
              </Flex>
            ) : null}
          </React.Fragment>
        ))}
      </Flex>
      {/* </Flex> */}
    </Flex>
  );

  // return (
  //   <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
  //     <Header label={"Manage"} isLoading={false} />
  //     <Flex width={"100%"} flexFlow={"wrap"} gap={"3"}>
  //       <ButtonComp label={"Cars"} onClick={() => onClickBtn("maagecar")} />
  //       <ButtonComp label={"Users"} onClick={() => onClickBtn("manageusers")} />

  //       {/* <Button bg={"primary"} w={"12rem"}>
  //         Cars
  //       </Button> */}
  //       {/* <Button
  //         bg={"primary"}
  //         onClick={() => onClickBtn("manageusers")}
  //         w={"12rem"}
  //       >
  //         Users
  //       </Button> */}
  //       <Button
  //         bg={"primary"}
  //         onClick={() => onClickBtn("managegroups")}
  //         w={"12rem"}
  //       >
  //         Groups
  //       </Button>
  //     </Flex>

  //     <Box mt={"2rem"}>
  //       <Text fontWeight={"bold"} textStyle={"sm"} color="fontdark">
  //         Pricing & Returns
  //       </Text>
  //       <Flex width={"100%"} flexFlow={"wrap"} gap={"3"}>
  //         <Button
  //           onClick={() => onClickBtn("return")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           View Returns
  //         </Button>
  //         <Button
  //           onClick={() => onClickBtn("pricing")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Pricing & Returns Rules
  //         </Button>
  //       </Flex>
  //     </Box>

  //     <Box mt={"2rem"}>
  //       <Text fontWeight={"bold"} textStyle={"sm"} color="fontdark">
  //         Custom Pricing
  //       </Text>
  //       <Flex width={"100%"} flexFlow={"wrap"} gap={"3"}>
  //         <Button
  //           onClick={() => onClickBtn("pricing")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Custom Pricing Rules
  //         </Button>
  //         <Button
  //           onClick={() => onClickBtn("custompricing")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Generate Custom Pricing
  //         </Button>
  //       </Flex>
  //     </Box>

  //     <Box mt={"2rem"}>
  //       <Text fontWeight={"bold"} textStyle={"sm"} color="fontdark">
  //         Commission
  //       </Text>
  //       <Flex width={"100%"} flexFlow={"wrap"} gap={"3"}>
  //         <Button
  //           onClick={() => onClickBtn("commissionsheets")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Commission Sheets
  //         </Button>
  //         <Button
  //           onClick={() => onClickBtn("commissionrules")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Commission Rules
  //         </Button>
  //       </Flex>
  //     </Box>

  //     <Box mt={"2rem"}>
  //       <Text fontWeight={"bold"} textStyle={"sm"} color="fontdark">
  //         Pricings
  //       </Text>
  //       <Flex width={"100%"} flexFlow={"wrap"} gap={"3"}>
  //         <Button
  //           onClick={() => onClickBtn("policies")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Policies
  //         </Button>
  //         <Button
  //           onClick={() => onClickBtn("duration")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Duration
  //         </Button>

  //         <Button
  //           onClick={() => onClickBtn("covertypes")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Cover Types
  //         </Button>
  //         <Button
  //           onClick={() => onClickBtn("claimamount")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Claim Limits
  //         </Button>
  //       </Flex>
  //     </Box>

  //     <Box mt={"2rem"}>
  //       <Text fontWeight={"bold"} textStyle={"sm"} color="fontdark">
  //         Settings
  //       </Text>
  //       <Flex width={"100%"} flexFlow={"wrap"} gap={"3"}>
  //         <Button onClick={() => onClickBtn("vat")} bg={"fontdark"} w={"12rem"}>
  //           VAT
  //         </Button>
  //         <Button
  //           onClick={() => onClickBtn("permissionprofiles")}
  //           bg={"fontdark"}
  //           w={"12rem"}
  //         >
  //           Persmissions
  //         </Button>
  //       </Flex>
  //     </Box>

  //     <Flex width={"100%"} flexFlow={"wrap"} gap={"3"} mt={"2rem"}>
  //       <Button
  //         onClick={() => onClickBtn("paymentsout")}
  //         bg={"primary"}
  //         w={"12rem"}
  //       >
  //         Payments Out
  //       </Button>
  //       <Button
  //         onClick={() => onClickBtn("paymentsreceived")}
  //         bg={"primary"}
  //         w={"12rem"}
  //       >
  //         Payments In
  //       </Button>
  //       <Button
  //         onClick={() => onClickBtn("coveredparts")}
  //         bg={"primary"}
  //         w={"12rem"}
  //       >
  //         Covered Parts
  //       </Button>
  //       <Button
  //         onClick={() => onClickBtn("schedule")}
  //         bg={"primary"}
  //         w={"12rem"}
  //       >
  //         Schedule
  //       </Button>
  //     </Flex>
  //   </Flex>
  // );
}

export default Manage;
